import { Language } from "@mui/icons-material";
import { Menu, MenuItem } from "@mui/material";
import React, { useMemo, useState } from "react";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";

import Box from "../Box";
import Button from "../Button";
import Typography from "../Typography";

interface IProps {
    isMiniSideNav: boolean;
    handleOnChange: (lang: string) => void;
}

const ButtonSwitcherLanguage: React.FC<IProps> = (props: IProps) => {

    const { listMultiLanguage, language } = useCommonComponentContext();

    const { isMiniSideNav, handleOnChange, ...rest } = props;

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const arrLanguage = useMemo(() => (listMultiLanguage || []), [listMultiLanguage]);

    const languageTitles: { [key: string]: any } = useMemo(() => {
        let newData: any;

        listMultiLanguage.forEach(item => {
            newData = {
                ...newData,
                [item.code]: {
                    title: item.name,
                    miniTitle: item.code,
                }
            };
        });

        return newData;
    }, [listMultiLanguage]);

    const languageTitle = useMemo(() => (
        props.isMiniSideNav
            ? languageTitles[language].miniTitle
            : languageTitles[language].title
    ), [props.isMiniSideNav, languageTitles, language]);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleLanguageChange = (lang: string) => {
        setAnchorEl(null);
        props.handleOnChange(lang);
    }

    return (
        <Box sx={{
            px: 4,
            py: 2,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1000,
            width: "100%",
            color: "#FFF",
            display: "flex",
            position: "sticky",
            alignItems: "center",
            background: "#42424a",
            justifyContent: "center",
        }}>
            <Button
                {...rest}
                fullWidth
                color="white"
                variant="outlined"
                id="language_button"
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                aria-controls={open ? "languageMenu" : undefined}
                startIcon={props.isMiniSideNav ? undefined : <Language />}
                onClick={handleClick}
            >
                {languageTitle}
            </Button>

            <Menu
                id="languageMenu"
                open={open}
                anchorEl={anchorEl}
                anchorReference={null}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "languageButton",
                }}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                {
                    arrLanguage.map((item, index) => (
                        <MenuItem
                            key={`${item.code}_${index}`}
                            selected={language === `${item.code}`}
                            onClick={() => handleLanguageChange(`${item.code}`)}
                        >
                            <Box display="flex" alignItems="center">
                                <Typography variant="button">
                                    {props.isMiniSideNav
                                        ? languageTitles[`${item.code}`].miniTitle
                                        : languageTitles[`${item.code}`].title
                                    }
                                </Typography>
                            </Box>
                        </MenuItem>
                    ))
                }
            </Menu>
        </Box>
    )
}

export default ButtonSwitcherLanguage;